import { render } from "./CalendarDay.vue?vue&type=template&id=01013076&scoped=true"
import script from "./CalendarDay.vue?vue&type=script&lang=js"
export * from "./CalendarDay.vue?vue&type=script&lang=js"

import "./CalendarDay.vue?vue&type=style&index=0&id=01013076&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01013076"]])

export default __exports__